import { normalizeRegionName, regionBillingCode } from '../../../../../helpers/addressParser'
import { BILLING_ADDRESS_SCOPE } from '../../../../../constants/billing'
import { RegionInstruction } from './RegionInstruction'

export class BillingRegionInstruction extends RegionInstruction {
  constructor ({ label, waitForNoLoaders, option }) {
    super({ label, waitForNoLoaders, option })
    this.name = 'BillingRegion'
    this.scope = BILLING_ADDRESS_SCOPE
  }

  setDefaultValue (params) {
    const regionName = regionBillingCode[params.billingInformation.regionCode]
    this.option = regionName ? normalizeRegionName(regionName) : undefined
  }
}
